import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import InboxRoundedIcon from '@mui/icons-material/InboxRounded';
import tokens from '../../theme/tokens';

const EmptyState = ({ title, description, icon, action }) => (
  <Box sx={{ textAlign: 'center', py: 5, px: 2, color: 'text.secondary' }}>
    <Box sx={{ width: 56, height: 56, mx: 'auto', mb: 1.5, borderRadius: '50%', bgcolor: tokens.color.surfaceAlt, display: 'grid', placeItems: 'center', color: tokens.color.textMuted }}>
      {icon || <InboxRoundedIcon />}
    </Box>
    <Typography variant="subtitle1" color="text.primary">
      {title}
    </Typography>
    {description && <Typography variant="body2" sx={{ mt: 0.5 }}>{description}</Typography>}
    {action && <Box sx={{ mt: 2 }}>{action}</Box>}
  </Box>
);

export default EmptyState;
